// extracted by mini-css-extract-plugin
export var active = "_ha-2";
export var recordingDot = "_ha-1";
export var recordingIndicator = "_ha-0";